import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=34ab7c78&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=ts"
export * from "./GroupForm.vue?vue&type=script&lang=ts"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=34ab7c78&prod&lang=scss&scoped=true"
import style1 from "./GroupForm.vue?vue&type=style&index=1&id=34ab7c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab7c78",
  null
  
)

export default component.exports